<template>
  <div class="form-group row">
    <label class="col-4 form-control-label">Часовой пояс</label>
    <div class="col-8">
      <multiselect
        :options="timeZones"
        :close-on-select="true"
        :show-labels="false"
        :value="value"
        v-model="timeZone"
        placeholder="Часовой пояс не выбран"
        track-by="id"
        label="name"
        autocomplete="off"
        @input="changeTimeZone"
      />
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import tzOffsets from './../../../helpers/tzOffsets'

export default {
  name: 'TcSelectTimeZone',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  components: {
    Multiselect
  },
  data () {
    return {
      timeZones: tzOffsets(),
      timeZone: {}
    }
  },
  methods: {
    changeTimeZone ($timeZone) {
      this.$emit('input', $timeZone ? $timeZone.id : null)
    }
  },
  created () {
    this.timeZone = this.timeZones.filter(zone => {
      return zone.id === this.value
    })[0]
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TcSelectTimeZone.vue?441b91aa